import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Wrapper } from "../Wrapper";
import { FAQItem } from "./FAQItem";
import { FAQ } from "./types/faq";
import { backgroundMapper, BackgroundVariant } from "../Section";
import { useIsTabletDown } from "../utils/use-media-breakpoints";
import { mobileDown } from "../theme/ecologi-breakpoints";
import { isImpactShop } from "../utils/is-impact-shop";

const Section = styled.section<{ isCompact?: boolean }>`
  color: ${(props) => props.theme.colors.charcoal};
  padding: 60px 0 70px;

  ${(props) =>
    props.isCompact &&
    css`
      padding-top: 0;
    `}
`;

const Title = styled.h3<{ isImpactPage?: boolean }>`
  font-size: 30px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 30px;

  ${(props) =>
    props?.isImpactPage
      ? css`
          @media ${mobileDown} {
            font-size: 28px;
            text-align: center;
          }
        `
      : css``}

  @media ${(props) => props.theme.bp.tabletUp} {
    font-size: 40px;
    text-align: center;
  }
`;

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const FAQs = ({ data, wrapper = true, slug }: any) => {
  const Container = wrapper ? Wrapper : ({ children }: any) => children;
  return (
    <LargeFaqContainer
      backgroundVariant={
        isImpactShop(slug) && useIsTabletDown()
          ? BackgroundVariant.TRANSPARENT
          : data?.backgroundVariant || BackgroundVariant.TRANSPARENT
      }
    >
      <Container>
        <Section isCompact={data.isCompact}>
          {!data.isCompact && (
            <Title isImpactPage={isImpactShop(slug)}>{data.title}</Title>
          )}
          <List>
            {data.questions.map((faq: FAQ, index: number) => (
              <FAQItem
                faq={faq}
                isOpenInitially={
                  data.isAllOpenInitially ||
                  (index === 0 && !data.isAllClosedInitially)
                }
                key={index}
                dividerColor={data?.divider_color}
              />
            ))}
          </List>
        </Section>
      </Container>
    </LargeFaqContainer>
  );
};

const LargeFaqContainer = styled("div")<{
  backgroundVariant: BackgroundVariant;
}>`
  background-color: ${(props) =>
    backgroundMapper[props.backgroundVariant](props.theme)};
`;
